/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DealDtoBaseResponse } from '../models/deal-dto-base-response';

@Injectable({
  providedIn: 'root',
})
export class ExcelService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiExcelProcessQuotePost
   */
  static readonly ApiExcelProcessQuotePostPath = '/api/Excel/process-quote';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelProcessQuotePost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiExcelProcessQuotePost$Plain$Response(params?: {
    body?: { 'formFile'?: Blob }
  }): Observable<StrictHttpResponse<DealDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelProcessQuotePostPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DealDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelProcessQuotePost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiExcelProcessQuotePost$Plain(params?: {
    body?: { 'formFile'?: Blob }
  }): Observable<DealDtoBaseResponse> {

    return this.apiExcelProcessQuotePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<DealDtoBaseResponse>) => r.body as DealDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelProcessQuotePost$Json()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiExcelProcessQuotePost$Json$Response(params?: {
    body?: { 'formFile'?: Blob }
  }): Observable<StrictHttpResponse<DealDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelProcessQuotePostPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DealDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelProcessQuotePost$Json$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiExcelProcessQuotePost$Json(params?: {
    body?: { 'formFile'?: Blob }
  }): Observable<DealDtoBaseResponse> {

    return this.apiExcelProcessQuotePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<DealDtoBaseResponse>) => r.body as DealDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiExcelProcessExistingQuotePost
   */
  static readonly ApiExcelProcessExistingQuotePostPath = '/api/Excel/process-existing-quote';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelProcessExistingQuotePost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiExcelProcessExistingQuotePost$Plain$Response(params?: {
    dealId?: number;
    body?: { 'formFile'?: Blob }
  }): Observable<StrictHttpResponse<DealDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelProcessExistingQuotePostPath, 'post');
    if (params) {
      rb.query('dealId', params.dealId, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DealDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelProcessExistingQuotePost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiExcelProcessExistingQuotePost$Plain(params?: {
    dealId?: number;
    body?: { 'formFile'?: Blob }
  }): Observable<DealDtoBaseResponse> {

    return this.apiExcelProcessExistingQuotePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<DealDtoBaseResponse>) => r.body as DealDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiExcelProcessExistingQuotePost$Json()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiExcelProcessExistingQuotePost$Json$Response(params?: {
    dealId?: number;
    body?: { 'formFile'?: Blob }
  }): Observable<StrictHttpResponse<DealDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ExcelService.ApiExcelProcessExistingQuotePostPath, 'post');
    if (params) {
      rb.query('dealId', params.dealId, {});
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DealDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiExcelProcessExistingQuotePost$Json$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiExcelProcessExistingQuotePost$Json(params?: {
    dealId?: number;
    body?: { 'formFile'?: Blob }
  }): Observable<DealDtoBaseResponse> {

    return this.apiExcelProcessExistingQuotePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<DealDtoBaseResponse>) => r.body as DealDtoBaseResponse)
    );
  }

}
